// import BionicLogo from 'components/BionicUI/bionicLogo/BionicLogo';
import HeaderSearchBar from 'components/search/HeaderSearchBar';
import { FC } from 'react';
import ProfileMenu from './profileMenu/ProfileMenu';
import { SearchContext } from 'components/search/GlobalSearchPopup';
import BurgerMenu from './burgerMenu/BurgerMenu';
import { cn } from 'lib/utils';

interface HeaderProps {
  showSearchBar?: boolean;
  showProfile?: boolean;
  linkLogo?: boolean;
  searchContext?: SearchContext;
}

const Header: FC<HeaderProps> = ({
  showSearchBar = true,
  showProfile = true,
  linkLogo = true,
  searchContext,
}) => {
  const isMinimal = !showProfile && !showSearchBar;

  return (
    <header
      className={cn(
        'grid sticky top-0 w-full h-[104px] z-20 place-content-center page-side-padding bg-gradient-to-b from-black to-black/0',
        isMinimal
          ? 'grid-cols-[1fr] justify-center sm:grid-cols-[auto_1fr_140px] sm:gap-6'
          : 'grid-cols-[auto_1fr_140px] gap-6'
      )}
    >
      <div
        className={cn(
          'grid items-center',
          isMinimal && 'justify-center sm:justify-start'
        )}
      >
        {linkLogo ? (
          <a className="no-underline hover:opacity-70" href="/dashboard">
            {/* <BionicLogo className={'block relative w-[128px]'} animate={false} /> */}
            <img
              src="/images/ground-zero-logo.svg"
              alt=""
              className="h-[42px] w-[174px] object-none"
            />
          </a>
        ) : (
          // <BionicLogo className={'block relative w-[128px]'} animate={false} />
          <img
            src="/images/ground-zero-logo.svg"
            alt=""
            className="h-[42px] w-[174px] object-none"
          />
        )}
      </div>
      <div className="grid place-content-center">
        {showSearchBar && <HeaderSearchBar searchContext={searchContext} />}
      </div>
      <div className="grid items-center justify-end">
        {showProfile && <ProfileMenu />}
        {showProfile && <BurgerMenu />}
      </div>
    </header>
  );
};

export default Header;
